export default __webpack_public_path__ + "static/media/q1.c53c0195.jpg";